/** NFR-09 published limits. Proposed v1 defaults; servers may override via configuration. */
export interface Limits {
  uploadMaxBytes: number;
  uploadVideoMaxBytes: number;
  uploadMaxLiveFilesPerTicket: number;
  uploadAllowedTypes: readonly string[];
  pageSizeDefault: number;
  pageSizeMax: number;
  sessionIdleMinutes: number;
  sessionAbsoluteHours: number;
  sessionRefreshDays: number;
  invitationDays: number;
  claimHeartbeatMinutes: number;
  claimExpiryMinutes: number;
  approvalRequestExpiryDays: number;
  releaseApprovalUseHours: number;
  deploymentUnknownAfterMinutes: number;
  idempotencyRetentionHours: number;
  rateLimitPerMinute: number;
}

export const DEFAULT_LIMITS: Limits = {
  uploadMaxBytes: 25 * 1024 * 1024,
  uploadVideoMaxBytes: 50 * 1024 * 1024,
  uploadMaxLiveFilesPerTicket: 20,
  uploadAllowedTypes: [
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'video/mp4',
    'video/webm',
    'video/quicktime',
    'text/plain',
    'text/csv',
    'text/markdown',
    'application/pdf',
  ],
  pageSizeDefault: 50,
  pageSizeMax: 100,
  sessionIdleMinutes: 30,
  sessionAbsoluteHours: 12,
  sessionRefreshDays: 14,
  invitationDays: 7,
  claimHeartbeatMinutes: 5,
  claimExpiryMinutes: 30,
  approvalRequestExpiryDays: 7,
  releaseApprovalUseHours: 24,
  deploymentUnknownAfterMinutes: 60,
  idempotencyRetentionHours: 24,
  rateLimitPerMinute: 300,
};
